import ActiveOffer          from './modules/activeOffer'
import Action               from './modules/action'
import Address              from './modules/address'
import Auth                 from './modules/auth'
import Auth2FA              from './modules/auth2FA'
import Availability         from './modules/availability'
import Brokers              from './modules/brokers'
import CommissionRules      from './modules/commissionRules'
import Configuration        from './modules/configuration'
import ContractGeneration   from './modules/contractGeneration'
import Customer             from './modules/customer'
import Channels             from './modules/channels'
import Deal                 from './modules/deal'
import Deals                from './modules/deals'
import DealHistorical       from './modules/dealHistorical'
import Facebook             from './modules/facebook'
import FacebookAccounts     from './modules/facebookAccounts'
import Files                from './modules/files'
import FieldGroupHasField   from './modules/fields'
import FormTracker          from './modules/formTracker'
import Funnel               from './modules/funnel'
import Funnels               from './modules/funnels'
import GroupsAvailability   from './modules/groupsAvailability'
import Historical           from './modules/historical'
import Idle                 from './modules/idle'
import Lead                 from './modules/lead'
import Managers             from './modules/managers'
import MarketingQueues      from './modules/marketingQueues'
import Notifications        from './modules/notifications'
import Offline              from './modules/offline'
import Origins              from './modules/origins'
import Product              from './modules/product'
import Proposal             from './modules/proposal'
import Register             from './modules/register'
import Reserve              from './modules/reserve'
import ReserveQueue         from './modules/reserveQueue'
import ResetPassword        from './modules/resetPassword'
import SalesTable           from './modules/salesTable'
import Simulation           from './modules/simulation'
import SimulatorRule        from './modules/simulatorRule'
import Supervisors          from './modules/supervisors'
import Tag                  from './modules/tag'
import Task                 from './modules/task'
import Team                 from './modules/team'
import TeamFilter           from './modules/teamFilter'
import Tokens               from './modules/tokens'
import User                 from './modules/user'
import Users                from './modules/users'
import UsersInactives       from './modules/usersInactives'
import Integration         from './modules/integration'
import PowerBi              from './modules/bi'
import News                 from './modules/news'
import S3Filesystem         from './modules/s3Filesystem'
import OpenSearch           from './modules/openSearch'
import Reports              from './modules/reports'
import LaunchDay            from './modules/launchDay'
import DigitalSignature		from './modules/digitalSignature'
import ERP                  from './modules/erp'
import Public               from './modules/public'
import ReportsCategory      from './modules/reportsCategory'
import GenerateReports      from './modules/generateReports'
import Dashboard            from './modules/dashboard'
import Reserves             from './modules/reserves'
import Groups               from './modules/groups'
import TeamsList            from './modules/teamsList'
import UsersList            from './modules/usersList'
import UnitsReserves        from './modules/unitsReserves'
import AvailabilityTransfer from './modules/availabilityTransfer'

const activeOffer           = ActiveOffer.build()
const action                = Action.build()
const address               = Address.build()
const auth                  = Auth.build()
const auth2FA               = Auth2FA.build()
const availability          = Availability.build()
const brokers               = Brokers.build()
const commissionRules       = CommissionRules.build()
const configuration         = Configuration.build()
const contractGeneration    = ContractGeneration.build()
const channels 				= Channels.build()
const customer              = Customer.build()
const deal                  = Deal.build()
const deals                 = Deals.build()
const dealHistorical        = DealHistorical.build()
const facebook              = Facebook.build()
const facebookAccounts      = FacebookAccounts.build()
const files                 = Files.build()
const fieldGroupHasField    = FieldGroupHasField.build()
const formTracker           = FormTracker.build()
const funnel                = Funnel.build()
const funnels               = Funnels.build()
const groupsAvailability    = GroupsAvailability.build()
const historical            = Historical.build()
const idle                  = Idle.build()
const lead                  = Lead.build()
const managers              = Managers.build()
const marketingQueues       = MarketingQueues.build()
const notifications         = Notifications.build()
const offline               = Offline.build()
const origins               = Origins.build()
const product               = Product.build()
const proposal              = Proposal.build()
const register              = Register.build()
const reserve               = Reserve.build()
const reserveQueue          = ReserveQueue.build()
const resetPassword         = ResetPassword.build()
const salesTable            = SalesTable.build()
const simulation            = Simulation.build()
const simulatorRule         = SimulatorRule.build()
const supervisors           = Supervisors.build()
const tag                   = Tag.build()
const task                  = Task.build()
const team                  = Team.build()
const teamFilter            = TeamFilter.build()
const tokens                = Tokens.build()
const user                  = User.build()
const integration          = Integration.build()
const powerBi               = PowerBi.build()
const users                 = Users.build()
const usersInactives        = UsersInactives.build()
const news                  = News.build()
const s3Filesystem          = S3Filesystem.build()
const openSearch            = OpenSearch.build()
const reports               = Reports.build()
const launchDay             = LaunchDay.build()
const digitalSignature      = DigitalSignature.build()
const erp                   = ERP.build()
const apiPublic             = Public.build()
const reportsCategory       = ReportsCategory.build()
const generateReports       = GenerateReports.build()
const dashboard             = Dashboard.build()
const reserves              = Reserves.build()
const groups                = Groups.build()
const teamsList             = TeamsList.build()
const usersList             = UsersList.build()
const unitsReserves         = UnitsReserves.build()
const availabilityTransfer  = AvailabilityTransfer.build()

export {
    activeOffer,
    action,
    address,
    auth,
    auth2FA,
    channels,
    deal,
    deals,
    dealHistorical,
    salesTable,
    availability,
    brokers,
    commissionRules,
    simulatorRule,
    simulation,
    configuration,
    contractGeneration,
    customer,
    facebook,
    facebookAccounts,
    files,
    fieldGroupHasField,
    formTracker,
    funnel,
    funnels,
    groupsAvailability,
    historical,
    idle,
    lead,
    managers,
    marketingQueues,
    notifications,
    offline,
    origins,
    product,
    proposal,
    register,
    reserve,
    reserveQueue,
    resetPassword,
    supervisors,
    tag,
    task,
    team,
    teamFilter,
    tokens,
    user,
    users,
    usersInactives,
    integration,
    powerBi,
    news,
    s3Filesystem,
    openSearch,
    reports,
    launchDay,
	digitalSignature,
    erp,
    apiPublic,
    reportsCategory,
    generateReports,
    dashboard,
    reserves,
    groups,
    teamsList,
    usersList,
    unitsReserves,
    availabilityTransfer
}